import { SelectOption } from '@lessonup/ui-components';
import { Language as LocaleLanguage } from '@lessonup/utils';
import { TFunction } from 'i18next';
import { Language } from '../../types/graphql';

/**
 * Language options used for AI tools for translating content.
 * Provides a list of supported languages with their display labels and corresponding language codes.
 */
export const getLanguageOptions = (t: TFunction): SelectOption<Language>[] => [
  { label: t('en_uk'), value: 'EN_UK' },
  { label: t('en_us'), value: 'EN_US' },
  { label: t('fr'), value: 'FR' },
  { label: t('nl'), value: 'NL' },
  { label: t('de'), value: 'DE' },
  { label: t('es'), value: 'ES' },
  { label: t('cy'), value: 'CY' },
  { label: t('gd'), value: 'GD' },
  { label: t('hi'), value: 'HI' },
  { label: t('it'), value: 'IT' },
  { label: t('ja'), value: 'JA' },
  { label: t('mn'), value: 'MN' },
  { label: t('pt'), value: 'PT' },
  { label: t('zh'), value: 'ZH' },
];

/**
 * Gets the language value for a given locale language
 * @param language - The locale language to convert (e.g., 'en', 'fr', 'nl')
 * @returns The corresponding Language enum value (e.g., 'EN_UK', 'FR', 'NL')
 */
export const getLanguageValue = (language: LocaleLanguage): Language => {
  switch (language) {
    case 'en':
      return 'EN_UK';
    case 'fr':
      return 'FR';
    case 'nl':
      return 'NL';
    default:
      return 'EN_UK';
  }
};
